import { loginRoute } from "./login";
import { logoutRoute } from "./logout";
import { testRoute } from "./test";

export default [loginRoute, logoutRoute, testRoute];
